import type { ListingAvailability } from '@bb/domain/dist/types/Listing';
import { featureEnabled } from 'utils';

export const TOGGLE_CARD_HEIGHT = 217; // toggle card height from ManageListingsLayout

export const APPT_DESK_BILLING_STATUS: Record<string, ListingAvailability> = {
  PRICE_CHANGE: 'Price Change',
  EXTENDED: 'Extended',
  DEAL_FELL_THROUGH: 'Deal Fell Through',
  NEW: 'New',
};

export const APPOINTMENT_DESK_LABELS = [
  '24 / 7 / 365 live answering service',
  'Incoming calls to manage your listing',
  'Experience and trained appointment specialists',
  'Technical email support',
  'Short code SMS delivery system',
];

export const LIVE_CONCIERGE_LABELS = [
  'Incoming and outgoing calls to manage your listings',
  'Outgoing showing confirmations',
  'Your own personal live concierge service',
];

export const COMBINED_LIVE_CONCIERGE_LABELS = [
  '24 / 7 / 365 live answering service',
  'Incoming and outgoing calls to manage your listings',
  'Experience and trained appointment specialists',
  'Technical email support',
  'Short code SMS delivery system',
  'Outgoing showing confirmations',
  'Your own personal live concierge service',
];

export const HOW_IT_WORKS_TEXT = `Add the phone number above to your brokerage's listings on the MLS, or
redirect any existing showing related phone numbers to this number, to
begin accepting showings requests for your listings over the phone.`;
